import React from 'react';
import Button from '@active/react-ui/Button';
import Locale from '@active/react-utils/i18n/Locale';
import {
  bool, func, string,
} from 'prop-types';
import pubSubInstance from '../../../../shared/utils/pubSub';
import { PubSubEnum, CONNECTSTATUS } from '../config';

export const CheckScanButton = ({
  status, checkAmount, disabled, setCurrentIndex,
}) => {
  const handleScan = () => {
    setCurrentIndex();
    pubSubInstance.dispatch(PubSubEnum.CheckScannerScan, checkAmount);
  };

  return <>
    {
      status === CONNECTSTATUS.connect && <Button type="primary" onClick={handleScan} className="check-scan" disabled={disabled}>
        <Locale id="checkout.lib.components.payment.check.scan" />
      </Button>
    }
  </>;
};

CheckScanButton.propTypes = {
  status: string.isRequired,
  checkAmount: string.isRequired,
  disabled: bool.isRequired,
  setCurrentIndex: func.isRequired,
};
